import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlertFullComponent } from "./med-icon-alert-full.component";

@NgModule({
  declarations: [
    MedIconAlertFullComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlertFullComponent,
  ],
})
export class MedIconAlertFullModule { }
